module.exports = __webpack_public_path__ + "img/liczba_rannych.77aa66cf.svg";